<template>
  <div class="role-actions">
    <template v-if="allOverPermission">
      <h3 class="role-actions__title">
        {{ 'role-actions.all-over-permission' | globalize }}
      </h3>
    </template>
    <template v-else>
      <div class="app-list">
        <template v-if="permission.actions">
          <div class="app-list__header app-list__cell--left">
            <h4 class="app-list__cell">
              {{ "role-actions.lbl-actions" | globalize }}
            </h4>
            <h4 class="app-list__cell app-list__cell--right">
              {{ "role-actions.lbl-delete" | globalize }}
            </h4>
          </div>
        </template>
        <ul class="role-actions__list-actions app-list">
          <li
            class="app-list__li"
            v-for="(item, i) in permission.actions"
            :key="`action-${i}`">
            <span
              class="
                app-list__cell
                app-list__cell--left
                role-actions__list-cell">
              {{ item.type }}
            </span>
            <div
              class="
                app-list__cell
                app-list__cell--right
                role-actions__list-cell">
              <permission-wrapper
                skip-alert
                page-name="roles"
                resource-name="role"
                action-name="delete">
                <button
                  v-ripple
                  class="role-actions__btn app__button-icon"
                  @click="deleteActionFromResource(item)"
                  :disabled="isDisabled">
                  <i class="role-actions__btn-icon mdi mdi-close" />
                </button>
              </permission-wrapper>
            </div>
          </li>

          <li class="app-list__li">
            <permission-wrapper
              skip-alert
              page-name="roles"
              resource-name="role"
              action-name="update">
              <form
                class="role-actions__form"
                @submit.prevent="isFormValid() && addActionToResource()"
                novalidate
              >
                <div
                  class="
                role-actions__input-field-wrp
                role-actions-selector
                app-list__cell
                app-list__cell">
                  <a-select
                    v-if="actions.length > 0"
                    :disabled="isDisabled"
                    placeholder="Please select action by click"
                    class="app-key-value__value"
                    @change="onActionChanged"
                  >
                    <a-select-option
                      v-for="item in availableActions"
                      :value="item"
                      :key="`${item}`">
                      {{ item }}
                    </a-select-option>
                  </a-select>
                </div>
                <div class="app-list__cell app-list__cell--right">
                  <button
                    type="submit"
                    v-ripple
                    class="app__button-raised"
                    :disabled="isDisabled"
                  >
                    <i class="role-actions__btn-icon mdi mdi-plus" />
                  </button>
                </div>
              </form>
            </permission-wrapper>
          </li>
        </ul>
      </div>
    </template>
  </div>
</template>

<script>
import RolesMixin from '@/vue/mixins/roles.mixin'
import ASelect from 'ant-design-vue/lib/select'
import PermissionWrapper from '@/vue/common/permission-wrapper'
import { required, resourceSelected } from '@validators'

const EVENTS = {
  updateRole: 'update-role',
  setResource: 'set-resource',
}

export default {
  name: 'role-actions',
  components: {
    ASelect,
    'a-select-option': ASelect.Option,
    PermissionWrapper,
  },
  mixins: [ RolesMixin ],
  props: {
    resource: { type: String, default: '' },
  },
  data () {
    return {
      action: '',
    }
  },

  validations: {
    action: { required },
    resource: { resourceSelected },
  },

  computed: {
    permission () {
      return this.role.permissions
        .find(item => item.resource === this.resource) ||
        this.role.permissions[0] || []
    },

    allOverPermission () {
      return this.resource === '*'
    },

    actionExists () {
      return Boolean(this.roleDetails.permissions.find(item =>
        item.resource === this.resource).actions.find(action =>
        action.type === this.action))
    },

    resourceExists () {
      return Boolean(this.roleDetails.permissions.find(item =>
        item.resource === this.newResource))
    },

    availableActions () {
      const result = []
      this.actions.forEach(a => {
        const found = this.permission.actions.find(o => {
          return o.type === a
        })
        if (!found) {
          result.push(a)
        }
      })
      return result
    },
  },

  watch: {
    roleDetails (newRole) {
      this.role = newRole
    },
  },

  async created () {
    await this.loadActions()
  },
  methods: {
    onActionChanged (value) {
      this.action = value
    },

    async addActionToResource () {
      if (!this.actionExists) {
        await this.addAction(this.role.id, this.action, this.resource)
        this.getRoleById(this.role.id)
        this.$emit(EVENTS.setResource, this.resource)

        if (!this.resource) {
          this.$emit(EVENTS.updateRole)
        }
      }
    },

    async deleteActionFromResource (action) {
      await this.deleteAction(this.role.id, action, this.resource)

      if (!this.resourceExists) {
        this.$emit(EVENTS.updateRole)
      }
    },
  },
}
</script>

<style lang="scss">
@import '~ant-design-vue/lib/select/style/index.css';

.role-actions__list-actions {
  margin-top: 1.5rem;
}

.role-actions .app-list__cell {
  display: inline-flex;
  align-items: center;
  padding: 1rem 1.25rem;
}

.role-actions__title {
  text-align: center;
}

.role-actions__btn {
  border-radius: 0;
  margin: 0 1rem;
}

.role-actions__btn-icon {
  font-size: 1.8rem;
  font-weight: 600;
}

.role-actions__input-field {
  max-width: 25rem;
}

.role-actions__input-field-wrp {
  height: 8.3rem;
}

.role-actions__form {
  display: flex;
  justify-content: space-between;
  flex: 1;
}

.role-actions__input-field-wrp.role-actions-selector {
  width: 50rem;
}
</style>
